import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ApiService } from '../core';
import { PageOptions } from '../core/models/pagination';
import { HandleError, HttpErrorHandler } from '../http-error-handler.service';
import { Product } from '../modelo/Product';

@Injectable({
    providedIn: 'root'
})
export class ServiciosService {

    private apiServer = '';
    private handleError: HandleError;

    constructor(
        private apiService: ApiService,
        private httpErrorHandler: HttpErrorHandler,
    ) {
        this.apiServer = environment.settings.apiServer;
        this.handleError = httpErrorHandler.createHandleError('ServiciosService');
    }

    /*************************************************************************************
    **REQUEST HTTP
    **************************************************************************************/
    async getProductosPorOrganizacionDeUsuarioConectadoData(pageOptions: PageOptions): Promise<any> {
        return this.getProductosPorOrganizacionDeUsuarioConectado(pageOptions).toPromise();
    }
    getProductosPorOrganizacionDeUsuarioConectado(pageOptions: PageOptions){
        const { page, pageSize, filter, orderBy, order } = pageOptions;
        const params = new HttpParams()
            .set('search', filter)
            .set('offset', page)
            .set('limit', pageSize)
            .set('orderBy', orderBy)
            .set('order', order);
        return this.apiService.get(this.apiServer + '/servicios/organizacion/activos', params)
            .pipe(
                catchError(this.handleError('ServiciosService.getProductosPorOrganizacionDeUsuarioConectado'))
            );
    }

    async getProductosPorTipoYOrganizacionDeUsuarioConectadoData(productType: any): Promise<any> {
        return this.getProductosPorTipoYOrganizacionDeUsuarioConectado(productType).toPromise();
    }
    getProductosPorTipoYOrganizacionDeUsuarioConectado(productType: any) {
        return this.apiService.get(this.apiServer + '/servicios/organizacion/tipo/' + productType + '/activos')
            .pipe(
                catchError(this.handleError('ServiciosService.getProductosPorTipoYOrganizacionDeUsuarioConectado'))
            );
    }
    
    async getProductosPorOrganizacionEstablecimientoDeUsuarioConectadoData(estab:string): Promise<any> {
        return this.getProductosPorOrganizacionEstablecimientoDeUsuarioConectado(estab).toPromise();
    }
    getProductosPorOrganizacionEstablecimientoDeUsuarioConectado(estab:string) {
        return this.apiService.get(this.apiServer + '/servicios/organizacion/estab/' + estab + '/activos/')
            .pipe(
                catchError(this.handleError('ServiciosService.getProductosPorOrganizacionEstablecimientoDeUsuarioConectado'))
            );
    }


    enviarProducto(product: Product) {
        if (product.id && product.uuid) {
            return this.apiService.put(this.apiServer + '/servicios', product)
                .pipe(map(data => data['product']));
        } else {
            return this.apiService.post(this.apiServer + '/servicios', product)
                .pipe(map(data => data['product']));
        }
    }
    
    borrarProducto(uuid: string): Observable<Product> {
        return this.apiService.delete(this.apiServer + '/servicios/' + uuid)
            .pipe(
                catchError(this.handleError('servicios.service.borrarProducto', uuid)))
    }
}
